import React from 'react';
import PropTypes from 'prop-types';

import InfoToolTip from '../../InfoToolTip';
import { useTranslation } from 'react-i18next';

function PaymentWarning({ hasPayment }) {
  const { t } = useTranslation();
  if (!hasPayment) {
    return null;
  }

  return (
    <div>
      <div
        className="label label-warning"
      >
        <i className="fa fa-warning" />
        {t("Utbetalt")}
      </div>
      <InfoToolTip title="Utbetalning">
        {t("periodAlreadyPaidWarning")}
      </InfoToolTip>
    </div>
  );
}

PaymentWarning.propTypes = {
  hasPayment: PropTypes.bool.isRequired,
};

export default PaymentWarning;
